// extracted by mini-css-extract-plugin
export default {"body":"eeFvR__body"};